import { PureQueryOptions } from 'apollo-client';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import addSuggestionsList from '../../mutations/addSuggestionsList';
import librariesQuery from '../../queries/libraries';
import { ViewerContext } from '../../types/viewer_context';

@Component({ components: {} })
export default class SuggestionsListCreateDialog extends Vue {
  @Getter public viewerContext!: ViewerContext;
  @Prop() public refetch!: PureQueryOptions;

  public librariesQuery = librariesQuery;

  public name = '';

  public bookshopMessage = '';

  public invitedLibrary = [];

  public invitedBookshopOptions = [
    { value: 'library-abc', text: 'Library ABC' },
  ];

  public okEnabled(): boolean {
    return (
      this.name !== '' &&
      !!this.invitedLibrary &&
      this.invitedLibrary.length > 0 &&
      this.bookshopMessage !== ''
    );
  }

  public reset(): void {
    this.invitedLibrary = [];
    this.name = '';
    this.bookshopMessage = '';
  }

  public show(): void {
    this.reset();
    this.getDialog().show();
  }

  public async handleOk(): Promise<void> {
    console.log(this.invitedLibrary[0]);
    const loader = this.$loading.show();
    try {
      await this.$apollo.mutate({
        mutation: addSuggestionsList,
        variables: {
          name: this.name,
          bookshopId: this.viewerContext.institutionId,
          libraryId: this.invitedLibrary[0] as any,
          bookshopMessage: this.bookshopMessage,
        },
        refetchQueries: [this.refetch],
      });
      this.$emit('suggestionsListCreated');
    } finally {
      loader.hide();
    }
  }

  private getDialog() {
    return this.$refs.newSuggestionsListDialog as any;
  }
}
